import { CharacterizationTypeEnum } from './enums';
import { IndustrialCodeType, TypeOfPrimaryFunctionOption, IndustrialCodeValue } from '.';

export class CharacterizeTestedPartyCodes {
  typeOfPrimaryFunctionOption: TypeOfPrimaryFunctionOption;
  codeType: IndustrialCodeType;
  industrialCodeValue: IndustrialCodeValue;
  characterizationType = CharacterizationTypeEnum.TypeOfOption;
}
